import { makeAutoObservable } from 'mobx'
import { type IEntitiesStore } from 'entities/EntitiesExport'
import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import { type UserOwner } from 'entities/Users/model/UserOwner'
import { InboxesViewStore } from 'pages/settings/pages/inboxes/pages'
import { GroupInboxesViewStore } from 'pages/settings/pages/inboxes/pages/inboxesView/store/groupInboxesViewStore'
import { runBeforeAddInbox } from 'pages/settings/lib/runBeforeAddInbox'
import { runBeforeAddNumber } from 'pages/settings/lib/runBeforeAddNumber'
import { type SettingsStore } from 'pages/settings/store/settingsStore'

export class InboxesStore {
  private _inboxesViewStore: InboxesViewStore
  private _groupInboxesViewStore: GroupInboxesViewStore

  constructor(private _settingsContext: SettingsStore, private _entities: IEntitiesStore) {
    this._inboxesViewStore = new InboxesViewStore(this, this._entities)
    this._groupInboxesViewStore = new GroupInboxesViewStore(this, this._entities)
    makeAutoObservable(this)
  }

  init = () => {
    this._inboxesViewStore.init()
    this._groupInboxesViewStore.init()
  }

  get entities() {
    return this._entities
  }

  get inboxesViewStore() {
    return this._inboxesViewStore
  }

  get settingsStore() {
    return this._settingsContext
  }

  get groupInboxesViewStore() {
    return this._groupInboxesViewStore
  }

  get currentUser() {
    return this._entities.usersStore.user as UserOwner
  }

  get isManageOrganizationInboxes() {
    return checkAccessPage(EnumAccessPageKeys.inbox_page, this._entities)
  }

  shouldRestrictListAccess = (): boolean =>
    Boolean(this.currentUser?.isMemberRole || !this.isManageOrganizationInboxes)

  manageInboxWrapper = (fn: () => void) => {
    runBeforeAddInbox(this._entities, fn)
  }

  manageNumberWrapper = (fn: () => void) => {
    runBeforeAddNumber(this._entities, fn)
  }
}
